import { render } from "./ProspectPeople.vue?vue&type=template&id=a703dd34"
import script from "./ProspectPeople.vue?vue&type=script&lang=js"
export * from "./ProspectPeople.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__